import { isSchoolLang } from "./langs";

// Адмін однієї мови школи (Лера — "en") може перемкнути кабінет на іншу мову (іспанську) без окремого акаунта.
// Перемикач лише на фронті: усі списки й форми адмінки й так працюють за adminInfo.accessType.
// Адмін "all" бачить усі мови колонками — йому перемикач не потрібен.
// Вибір мови памʼятаємо окремо для кожного акаунта (в одному браузері можуть входити різні адміни)
const keyOf = (id) => `adminLang:${id}`;

export const applyAdminLang = (me) => {
  if (!me || me.userType !== "admin" || !isSchoolLang(me.accessType)) return me;
  let saved = null;
  try {
    saved = localStorage.getItem(keyOf(me._id));
  } catch (e) {}
  return { ...me, homeAccessType: me.accessType, accessType: isSchoolLang(saved) ? saved : me.accessType };
};

export const canSwitchAdminLang = (me) => Boolean(me?.homeAccessType);

export const switchAdminLang = (me, key) => {
  try {
    localStorage.setItem(keyOf(me._id), key);
  } catch (e) {}
  // Перезавантаження — щоб усі сторінки (у кожної свій запит auth/me) підхопили нову мову
  window.location.reload();
};
